import React, { useEffect } from 'react';
import banner_img from '../../../images/banner-picture.png';
import login_logo from '../../../images/loginlogo.png';
import "./EmailVerified.css";
import { Button } from '@mui/material';
import HorizontalLinearStepper from '../../Stepper/Stepper';
import { useNavigate } from 'react-router-dom';
// import chevronleft from '../../images/chevronleft.svg';

function EmailVerifiedComp() {
    const navigate = useNavigate()
    useEffect(() => {
        // Check localStorage
        const stepTwoComplete = localStorage.getItem("signupStepTwoComplete");

        if (!stepTwoComplete) {
            navigate("/signupone"); // Redirect to first step
        }
    }, [navigate]);
    return (
        <>
            {/* <section className='login-page-one code-verify-section'>
                <div className='container-fluid p-0'>
                    <div className='row m-0'>
                        <div className='col-md-6'>
                            <div className='banner-contents'>
                                <div className='banner-image'>
                                    <img src={banner_img} alt="banner-image"></img>
                                </div>
                                <div className='text-overlay'>
                                    <h5>Welcome Back!</h5>
                                    <p>Elevate your business insights with precision. Log in to discover and refine your Ideal Customer Profiles effortlessly.</p>
                                    <div className='doted-tabs d-flex justify-content-center'>
                                        <div className='fade-dot'>
                                            <a href=""><i class="fa fa-circle" aria-hidden="true"></i></a>
                                        </div>
                                        <div className='fade-dot'>
                                            <a href=""><i class="fa fa-circle" aria-hidden="true"></i></a>
                                        </div>
                                        <div className='fade-dot'>
                                            <a href=""><i class="fa fa-circle" aria-hidden="true"></i></a>
                                        </div>
                                        <div className='fade-dot'>
                                            <a href=""><i class="fa fa-circle" aria-hidden="true"></i></a>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='login-right-block'>
                                <div className='login-logoimg text-center forgotpw-block'>
                                    <img src={login_logo} alt="login-logo"></img>
                                </div>
                                <div className='login-information code-verify'>
                                    <div className='code-verify-success text-center'>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            width="78"
                                            height="78"
                                            viewBox="0 0 682.667 682.667"
                                            xmlSpace="preserve"
                                        >
                                            <defs>
                                                <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                                    <stop offset="0%" style={{ stopColor: "#F0675C", stopOpacity: 1 }} />
                                                    <stop offset="100%" style={{ stopColor: "#F5A243", stopOpacity: 1 }} />
                                                </linearGradient>
                                            </defs>

                                            <g>
                                                <defs>
                                                    <clipPath id="b" clipPathUnits="userSpaceOnUse">
                                                        <path
                                                            d="M0 512h512V0H0Z"
                                                            fill="#000000"
                                                            opacity="1"
                                                        ></path>
                                                    </clipPath>
                                                </defs>
                                                <mask id="a">
                                                    <rect width="100%" height="100%" fill="#ffffff" opacity="1"></rect>
                                                </mask>
                                                <g mask="url(#a)">
                                                    <path
                                                        d="m0 0-134.174-134.174-63.873 63.872"
                                                        style={{
                                                            strokeWidth: 40,
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeMiterlimit: 10,
                                                        }}
                                                        transform="matrix(1.33333 0 0 -1.33333 473.365 251.884)"
                                                        fill="none"
                                                        stroke="url(#gradient1)" // Apply gradient to stroke
                                                    ></path>
                                                    <g clipPath="url(#b)" transform="matrix(1.33333 0 0 -1.33333 0 682.667)">
                                                        <path
                                                            d="M0 0c0-130.339-105.661-236-236-236S-472-130.339-472 0s105.661 236 236 236S0 130.339 0 0Z"
                                                            style={{
                                                                strokeWidth: 40,
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeMiterlimit: 10,
                                                            }}
                                                            transform="translate(492 256)"
                                                            fill="none"
                                                            stroke="url(#gradient1)" // Apply gradient to stroke
                                                        ></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>
                                    <p className='pw-texts text-center'>Code Verified! You can now reset your password.</p>
                                    <div className='form-login text-left'>

                                        <div className="btn-orange reset">
                                            <button className='reset-btn'>Reset Password</button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className='login-page-one code-verify-section'>
                <div className='container-fluid p-0'>
                    <div className='row m-0 row-password'>
                        <div className='col-md-6 codeverify-col'>
                            <div className='login-right-block logo-left-block mb-0'>
                                <div className='login-logoimg text-center forgotpw-block'>
                                    <img src={login_logo} alt="login-logo" className="login_logo_img"></img>
                                </div>
                            </div>
                            <div className='banner-contents'>
                                <div className='banner-image'>
                                    {/* <img src={banner_img} alt="banner-image"></img> */}
                                    <div className='text-overlay'>
                                        <h5>Let's Setup Your Operating Agreement</h5>
                                        <p>Elevate your business insights with precision. Log in to discover and refine your Ideal Customer Profiles effortlessly.</p>

                                    </div>
                                </div>


                            </div>
                        </div>
                        <div className='col-md-6 codeverify-col-two'>
                            <div className='login-right-block desktop-view'>
                                <div className='login-logoimg text-center forgotpw-block'>
                                    <img src={login_logo} alt="login-logo" className="login_logo_img"></img>
                                </div>
                            </div>
                            <div className="stepper d-flex justify-content-between align-items-center">
                                {/* <div className="stepper-innner">
                                              <a className=" d-flex flex-column align-items-center gap-1">
                                                <div className="stepper-dot-fade active"></div>
                                                <div className="step-no-fade active">Step 1</div>
                                              </a>
                                            </div>
                                            <div className="stepper-line "></div>
                                            <div className="stepper-innner">
                                              <Link
                                                onClick={handleSubmit}
                                                className=" d-flex flex-column align-items-center gap-1"
                                              >
                                                <div className="stepper-dot-fade"></div>
                                                <div className="step-no-fade">Step 2</div>
                                              </Link>
                                            </div> */}
                                <HorizontalLinearStepper activeStepProp={3} />
                            </div>
                            <div className='login-box'>
                                <div className='login-information code-verify'>
                                    <div className='code-verify-success text-center'>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            width="78"
                                            height="78"
                                            viewBox="0 0 682.667 682.667"
                                            xmlSpace="preserve"
                                        >
                                            <defs>
                                                <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                                    <stop offset="0%" style={{ stopColor: "#F0675C", stopOpacity: 1 }} />
                                                    <stop offset="100%" style={{ stopColor: "#F5A243", stopOpacity: 1 }} />
                                                </linearGradient>
                                            </defs>

                                            <g>
                                                <defs>
                                                    <clipPath id="b" clipPathUnits="userSpaceOnUse">
                                                        <path
                                                            d="M0 512h512V0H0Z"
                                                            fill="#000000"
                                                            opacity="1"
                                                        ></path>
                                                    </clipPath>
                                                </defs>
                                                <mask id="a">
                                                    <rect width="100%" height="100%" fill="#ffffff" opacity="1"></rect>
                                                </mask>
                                                <g mask="url(#a)">
                                                    <path
                                                        d="m0 0-134.174-134.174-63.873 63.872"
                                                        style={{
                                                            strokeWidth: 40,
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeMiterlimit: 10,
                                                        }}
                                                        transform="matrix(1.33333 0 0 -1.33333 473.365 251.884)"
                                                        fill="none"
                                                        stroke="url(#gradient1)" // Apply gradient to stroke
                                                    ></path>
                                                    <g clipPath="url(#b)" transform="matrix(1.33333 0 0 -1.33333 0 682.667)">
                                                        <path
                                                            d="M0 0c0-130.339-105.661-236-236-236S-472-130.339-472 0s105.661 236 236 236S0 130.339 0 0Z"
                                                            style={{
                                                                strokeWidth: 40,
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeMiterlimit: 10,
                                                            }}
                                                            transform="translate(492 256)"
                                                            fill="none"
                                                            stroke="url(#gradient1)" // Apply gradient to stroke
                                                        ></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>
                                    {/* <p className='pw-texts text-center'>Email Verified Successfully!</p> */}
                                    <p className='pw-texts text-center'>You've been successfully registered! Start exploring now.</p>

                                    <div className='form-login text-left'>

                                        <div className="btn-orange reset">
                                            {/* <button className='reset-btn' onClick={()=> navigate("/sign-up-success")}>Continue</button> */}
                                            <button className='reset-btn' onClick={() => {
                                                localStorage.removeItem("signupStepTwoComplete")
                                                localStorage.removeItem("signupStepTwoFormData")
                                                navigate("/login")
                                            }}>Go to Login</button>

                                        </div>
                                        {/* <div className="btn-orange reset">
                                            <button className='reset-btn' onClick={() => navigate("/login")}>Go to Dashboard</button>
                                        </div>
                                        <div className="btn-orange reset">
                                            <button className='reset-btn' onClick={() => navigate("/login")}>Verify Email</button>
                                        </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default EmailVerifiedComp;